import { Dispatch } from "redux";
import axios from "axios";
import {
  STRIPE_CREATE_SESSION_REQUEST,
  STRIPE_CREATE_SESSION_SUCCESS,
  STRIPE_CREATE_SESSION_FAILURE,
  STRIPE_PAYMENT_SUCCESS,
  STRIPE_PAYMENT_FAILURE,
} from "../types/stripeTypes";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

export const createStripeSession =
  (bookingData: any) => async (dispatch: Dispatch) => {
    dispatch({ type: STRIPE_CREATE_SESSION_REQUEST });

    try {
      API.defaults.headers.common["Authorization"] =
        `Bearer ${localStorage.getItem("token")}`;
      const response = await API.post(
        "/payment/create-checkout-session",
        bookingData
      );
      dispatch({
        type: STRIPE_CREATE_SESSION_SUCCESS,
        payload: response.data,
      });
      window.location.href = response.data.data.url;
    } catch (error: any) {
      dispatch({
        type: STRIPE_CREATE_SESSION_FAILURE,
        payload: error.response?.data?.message || "Failed to fetch vehicles",
      });
    }
  };

export const verifyPayment =
  (sessionId: string) => async (dispatch: Dispatch) => {
    dispatch({ type: "VERIFY_PAYMENT_REQUEST" });

    try {
      API.defaults.headers.common["Authorization"] =
        `Bearer ${localStorage.getItem("token")}`;

      const response = await API.get(
        `/payment/verify-payment?session_id=${sessionId}`
      );
      dispatch({
        type: STRIPE_PAYMENT_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      dispatch({
        type: STRIPE_PAYMENT_FAILURE,
        payload: error.response?.data?.message || "Payment verification failed",
      });
    }
  };
